import { validations } from "./Validations";
import { Tooltip, Forms } from "@types/FormTypes";
import {__} from "@wordpress/i18n";

// Constants for form field labels, options, and tooltips
const LABELS = {
    title: __("Dados para a simulação", "df-simulators"),
    loanValue: __("Capital em dívida", "df-simulators"),
    interestRate: __("Taxa de juro (spread + euribor)", "df-simulators"),
    installmentsToPay: __("Prestações a pagar (em meses)", "df-simulators"),
};

const TOOLTIPS: Record<string, Tooltip> = {
    loanValue: {
        title: __("Capital em dívida", "df-simulators"),
        content: __("Valor total que resta para ser pago do empréstimo.", "df-simulators"),
        placement: "right",
    },
    interestRate: {
        title: __("Taxa de juro", "df-simulators"),
        content: __("Taxa de juros que inclui spread e euribor.", "df-simulators"),
        placement: "right",
    },
    installmentsToPay: {
        title: __("Prestações a pagar", "df-simulators"),
        content: __("Número total de prestações em meses ainda a serem pagas.", "df-simulators"),
        placement: "right",
    },
};

// Constants for API configuration
const API_BASE_URL = `${window.location.origin}/wp-json/simulators/v1/mortgage-payment`;
const PROCESS_TYPE = 4;
const OPERATION_TYPE = 2;


/**
 * Simulator custom URL - Check if exists some custom URL for this block
 * [==START==]
 */
let MIDDLEWARE_API_URL = API_BASE_URL;
const rootElement = document.querySelector('[data-block="tool-block"]') as HTMLElement | null;
if ( rootElement !== null ) {
  const NEW_URL = rootElement.getAttribute('data-tool-managment');
  if ( NEW_URL !== null && NEW_URL !== '' ) {
    MIDDLEWARE_API_URL = NEW_URL;
  }
}
/* [==END==] */


export const forms: Forms = {
    mortgage_payment: {
        validation: validations.mortgage_payment, // Validação específica
        api: {
            url: MIDDLEWARE_API_URL, // Base URL da API
            processType: PROCESS_TYPE, // Tipo de processamento
            operationType: OPERATION_TYPE, // Tipo de operação
        },
        fields: [
            {
                type: "title",
                label: LABELS.title,
            },
            {
                type: "number",
                label: LABELS.loanValue,
                name: "loan_value",
                icon: "currency",
                defaultValue: 100000,
                tooltip: TOOLTIPS.loanValue,
                clinicName: 'totalLoan'
            },
            {
                type: "number",
                label: LABELS.interestRate,
                name: "interest_rate",
                icon: "percentage",
                defaultValue: 1.5,
                tooltip: TOOLTIPS.interestRate,
                clinicName: 'spreadValue'
            },
            {
                type: "number",
                label: LABELS.installmentsToPay,
                name: "installments_to_pay",
                //icon: "months",
                defaultValue: 360,
                tooltip: TOOLTIPS.installmentsToPay,
            },
        ],
    },
};
